import { render } from "./Input.vue?vue&type=template&id=b4854b5c"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__